var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 300 52.499999",
    height: 70,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5b61b963f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 51.210938 18.230469 L 255.007812 18.230469 L 255.007812 46.800781 L 51.210938 46.800781 Z M 51.210938 18.230469 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.743693, 0, 0, 0.742924, 12.844531, 31.775482)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.0010497 1.001514 L 377.617173 1.001514 ",
    stroke: "#07bdba",
    strokeWidth: 2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5b61b963f4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#07bdba",
    d: "M 255.007812 46.800781 L 51.179688 46.800781 L 51.179688 18.308594 L 255.007812 18.308594 Z M 255.007812 46.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "../static/envizi-price-estimator/assets/Bar.c649fc6590fb8327f2c1cd9459a66f26.svg";
export { ForwardRef as ReactComponent };